import { reducer as formReducer } from 'redux-form'
import { combineReducers } from 'redux'
import { LoginReducer } from './views/pages/StartPage/SigninPage/LoginReducer'
import TaxReducer from './views/Accounts/Taxation/TaxReducer'
import { VNCReducer } from './views/Accounts/VendorNCustomer/VNCReducer'
import UOMReducer from './views/Inventory/UOM/UOMReducer'
import invoiceReducer from './views/Accounts/Voucher/Invoice/invoice.reducer'
import miscReducer from './views/Misc/misc.reducer'
import listReducer from './views/Misc/Lists/list.reducer';
import CompanyReducer from './views/pages/Settings/CompanyFilling/company.reducer'
import bankReducer from './views/Accounts/Banks/bank.reducer'
import dcReducer from './views/pages/Settings/Default content/dc.reducer'
import { isOffline } from './containers/isOfflineReducer'
import userReducer from '../src/views/pages/Settings/UserReducer'
import DashReducer from '../src/views/dashboard/DashReducer'
import { SignUpReducer } from './views/pages/StartPage/SignUp/SignUpReducer'
import { DESTROY_ISLOGIN } from './Helper/actionsTypes'
import ledgerReducer from './views/Accounts/Ledgers/ledger.reducer'
import changeState from './containers/ChangeStateReducer'
import ac_groupReducer from './views/Accounts/Group/ac_group.reducer'
import receiptReducer from './views/Accounts/Voucher/Receipts/receipt.reducer'
import LedgerRecieptReducer from './views/Accounts/Reports/Ledger/LedgerContent/LedgerReducer'
import purchaseReducer from './views/Accounts/Voucher/Purchase/purchase.reducer'
import expenseReducer from './views/Accounts/Voucher/Expenses/expense.reducer'
import paymentReducer from './views/Accounts/Voucher/Payment/payment.reducer'
import { returnsReducer } from './views/Accounts/Reports/Returns/returnsReducer'
import { helpSupport } from './views/pages/Settings/HelpAndSupport/helpSupport'
import { planReducer } from './views/pages/CheckoutPage/PrivatePayment/planReducer'
import superAdminReducer from './views/SuperAdmin/superAdminReducer'

export const rootReducer = combineReducers({
  form: formReducer,
  auth: LoginReducer,
  superAdmin: superAdminReducer,
  signupred: SignUpReducer,
  plan: planReducer,
  dash: DashReducer,
  changeState: changeState,
  taxation: TaxReducer,
  VNC: VNCReducer,
  uom: UOMReducer,
  invoice: invoiceReducer,
  purchase: purchaseReducer,
  expense: expenseReducer,
  payment: paymentReducer,
  misc: miscReducer,
  lists: listReducer,
  company: CompanyReducer,
  bank: bankReducer,
  dc: dcReducer,
  nw: isOffline,
  user: userReducer,
  ledger: ledgerReducer,
  acGroup: ac_groupReducer,
  receipt: receiptReducer,
  reportL: LedgerRecieptReducer,
  reportR: returnsReducer,
  support: helpSupport
})

const appReducer = (state, action) => {
  if (action.type === DESTROY_ISLOGIN) {
    localStorage.clear();
    state = undefined
  }
  return rootReducer(state, action)
};
export default appReducer